'use client'

import { useEffect, useRef, useState } from 'react'

export function ReplayWidget({ data }) {
  console.log('data ReplayWidget', data)
  const [position, setPosition] = useState({ left: 20, top: 20 })
  const [isDragging, setIsDragging] = useState(false)
  const [showWidget, setShowWidget] = useState(true)
  const [reelsData, setReelsData] = useState(null)
  const [urlReels, setUrlReels] = useState(null)
  const [isPreview, setIsPreview] = useState(false)
  const [hasBeenManuallyPositioned, setHasBeenManuallyPositioned] = useState(false)

  // Refs for drag functionality
  const draggableRef = useRef(null)
  const videoContainerRef = useRef(null)
  const startPos = useRef({ x: 0, y: 0 })
  const dragOffset = useRef({ x: 0, y: 0 })
  const lastPos = useRef({ x: 0, y: 0 })
  const dragDistance = useRef({ x: 0, y: 0 })
  const velocityRef = useRef({ x: 0, y: 0 })
  const hitCount = useRef(0)
  const animationRef = useRef(null)
  const isMouseUp = useRef(false)

  const DRAG_THRESHOLD = 10
  const MAX_VELOCITY = 3
  const MAX_HITS = 2

  const closeButtonRef = useRef(null)
  const borderThumbRef = useRef(null)

  const iframeRef = useRef(null)
  const replayTextRef = useRef(null)

  const isOldAndroid = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('android') > -1) {
      const androidVersion = userAgent.match(/android\s([0-9.]*)/)
      if (androidVersion && androidVersion[1]) {
        const version = parseFloat(androidVersion[1])
        return version <= 6.0
      }
    }
    return false
  }

  const getDragThreshold = () => {
    return isOldAndroid() ? 15 : DRAG_THRESHOLD
  }

  const getTapThreshold = () => {
    return isOldAndroid() ? 30 : DRAG_THRESHOLD + 20
  }

  const getIframeContainer = () => {
    const containerIframe = document.getElementById('container-iframe-storix')
    if (typeof containerIframe !== 'undefined' && containerIframe !== null) {
      return containerIframe
    }
    return null
  }

  useEffect(() => {
    const fetchReelsData = async () => {
      const platform = data.platform
      const location = data.location
      const product_id = data.product_id

      let previewReplay = false
      if (data.location) {
        const url = new URL(location)
        const urlParams = new URLSearchParams(url.search)
        previewReplay = urlParams.get('previewreplay') === 'true'
        setIsPreview(previewReplay)
      }

      if (!previewReplay) {
        try {
          const response = await fetch(`https://api.replay.com.br/api/reels/${platform}/${data.store_id}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              product_id: product_id,
              location: location,
            }),
          })

          if (response.ok) {
            const dataCollection = await response.json()
            const encodedLocation = encodeURIComponent(location)
            const newUrlReels = `https://reels.empreender.plus/reels/${data.store_id}/${platform}/${encodedLocation}/${product_id}`

            setUrlReels(newUrlReels)
            if (dataCollection.config && dataCollection.collection) {
              setReelsData({
                config: dataCollection.config.data,
                collection: dataCollection.collection,
              })

              // fetch('https://public.empreender.app/replay/events', {
              //   method: 'POST',
              //   headers: { 'Content-Type': 'application/json' },
              //   body: JSON.stringify({
              //     event: 'pageview',
              //     ref1_id: data.store_id,
              //     ref2_id: product_id,
              //   }),
              // })
            }
          }
        } catch (error) {
          console.error('Error fetching reels data:', error)
        }
      } else {
        const newUrlReels = `https://reels.empreender.plus/reels/1/preview/1/1`
        setUrlReels(newUrlReels)
        setReelsData({
          config: data.data.config,
          collection: data.data.collection,
        })
      }
    }

    fetchReelsData()
  }, [data])

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === 'REELS_CLOSED' && iframeRef.current) {
        iframeRef.current.style.display = 'none'
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  useEffect(() => {
    const style = document.createElement('style')
    style.textContent = `
      html.is-replay-animated,
      body.is-replay-animated {
        overflow-x: hidden !important;
        width: 100vw !important;
        max-width: 100vw !important;
        position: relative !important;
      }
      @media screen and (max-width: 768px) {
        html.is-replay-animated,
        body.is-replay-animated {
          width: 100vw !important;
          max-width: 100vw !important;
          overflow-x: hidden !important;
          position: relative !important;
          left: 0 !important;
          right: 0 !important;
        }
      }
    `
    document.head.appendChild(style)

    const el = replayTextRef.current
    if (!el) return

    const handleStart = () => {
      document.documentElement.classList.add('is-replay-animated')
      document.body.classList.add('is-replay-animated')
    }

    const handleEnd = () => {
      document.documentElement.classList.remove('is-replay-animated')
      document.body.classList.remove('is-replay-animated')
    }

    el.addEventListener('animationstart', handleStart)
    el.addEventListener('animationend', handleEnd)

    return () => {
      el.removeEventListener('animationstart', handleStart)
      el.removeEventListener('animationend', handleEnd)
      if (document.head.contains(style)) {
        document.head.removeChild(style)
      }
    }
  }, [reelsData])

  // Handle drag events
  useEffect(() => {
    const handleMouseMove = (e) => {
      e.preventDefault()
      isMouseUp.current = false
      dragDistance.current = {
        x: e.clientX - startPos.current.x,
        y: e.clientY - startPos.current.y,
      }

      if (Math.abs(dragDistance.current.x) > DRAG_THRESHOLD || Math.abs(dragDistance.current.y) > DRAG_THRESHOLD) {
        if (isDragging) {
          isMouseUp.current = true
          setHasBeenManuallyPositioned(true)
          moveElement(e.clientX, e.clientY)
          velocityRef.current = {
            x: capVelocity(e.clientX - lastPos.current.x, MAX_VELOCITY),
            y: capVelocity(e.clientY - lastPos.current.y, MAX_VELOCITY),
          }
          lastPos.current = { x: e.clientX, y: e.clientY }
        }
      }
    }

    const handleMouseUp = () => {
      if (isDragging) {
        setIsDragging(false)
        if (draggableRef.current) {
          draggableRef.current.style.cursor = 'pointer'
        }
        hitCount.current = 0
        animateBounce()
      }
      setTimeout(() => {
        isMouseUp.current = false
      }, 0)
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [isDragging])

  const handleMouseDown = (e) => {
    e.preventDefault()
    startPos.current = { x: e.clientX, y: e.clientY }
    dragDistance.current = { x: 0, y: 0 }
    setIsDragging(true)
    isMouseUp.current = false

    const rect = draggableRef.current.getBoundingClientRect()
    dragOffset.current = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    }
    lastPos.current = { x: e.clientX, y: e.clientY }

    if (draggableRef.current) {
      draggableRef.current.style.cursor = 'grabbing'
      draggableRef.current.classList.remove('bounce')
    }
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current)
    }
  }

  const moveElement = (clientX, clientY) => {
    if (!draggableRef.current) return

    const draggableRect = draggableRef.current.getBoundingClientRect()
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight

    let newX = clientX - dragOffset.current.x
    let newY = clientY - dragOffset.current.y

    if (draggableRef.current.style.position === 'absolute') {
      const html = document.documentElement
      const htmlRect = html.getBoundingClientRect()

      newX = newX - htmlRect.left
      newY = newY - htmlRect.top

      newX = Math.max(0, Math.min(htmlRect.width - draggableRect.width, newX))
      newY = Math.max(0, Math.min(htmlRect.height - draggableRect.height, newY))
    } else {
      newX = Math.max(0, Math.min(windowWidth - draggableRect.width, newX))
      newY = Math.max(0, Math.min(windowHeight - draggableRect.height, newY))
    }

    draggableRef.current.style.left = `${newX}px`
    draggableRef.current.style.top = `${newY}px`
  }

  const animateBounce = () => {
    if (hitCount.current >= MAX_HITS || !draggableRef.current) return

    const draggableRect = draggableRef.current.getBoundingClientRect()
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight

    let newX = draggableRect.left + velocityRef.current.x
    let newY = draggableRect.top + velocityRef.current.y

    if (draggableRef.current.style.position === 'absolute') {
      const html = document.documentElement
      const htmlRect = html.getBoundingClientRect()

      newX = newX - htmlRect.left
      newY = newY - htmlRect.top

      if (newX < 0 || newX + draggableRect.width > htmlRect.width) {
        velocityRef.current.x = -velocityRef.current.x * 0.4
        newX = newX < 0 ? 0 : htmlRect.width - draggableRect.width
        hitCount.current++
      }
      if (newY < 0 || newY + draggableRect.height > htmlRect.height) {
        velocityRef.current.y = -velocityRef.current.y * 0.4
        newY = newY < 0 ? 0 : htmlRect.height - draggableRect.height
        hitCount.current++
      }
    } else {
      if (newX < 0 || newX + draggableRect.width > windowWidth) {
        velocityRef.current.x = -velocityRef.current.x * 0.4
        newX = newX < 0 ? 0 : windowWidth - draggableRect.width
        hitCount.current++
      }
      if (newY < 0 || newY + draggableRect.height > windowHeight) {
        velocityRef.current.y = -velocityRef.current.y * 0.4
        newY = newY < 0 ? 0 : windowHeight - draggableRect.height
        hitCount.current++
      }
    }

    draggableRef.current.style.left = `${newX}px`
    draggableRef.current.style.top = `${newY}px`

    if (hitCount.current < MAX_HITS && (Math.abs(velocityRef.current.x) > 1 || Math.abs(velocityRef.current.y) > 1)) {
      animationRef.current = requestAnimationFrame(animateBounce)
    } else if (hitCount.current >= MAX_HITS) {
      setTimeout(() => {
        hitCount.current = 0
        velocityRef.current = { x: 0, y: 0 }
      }, 1000)
    }
  }

  const capVelocity = (velocity, maxVelocity) => {
    return Math.max(-maxVelocity, Math.min(maxVelocity, velocity))
  }

  const changePosition = (containerPosition: null | HTMLElement) => {
    if (hasBeenManuallyPositioned || !draggableRef.current || !reelsData?.config) return

    const containerRect = containerPosition
      ? containerPosition.getBoundingClientRect()
      : {
          left: 0,
          right: window.visualViewport?.width || window.innerWidth,
          bottom: window.visualViewport ? window.visualViewport.height : document.documentElement.clientHeight,
          top: 0,
          width: window.visualViewport?.width || window.innerWidth,
          height: window.visualViewport ? window.visualViewport.height : document.documentElement.clientHeight,
        }

    const width = containerPosition ? containerPosition.clientWidth : window.innerWidth

    const { config } = reelsData
    const isMobile = width <= 600
    const side_space = isMobile ? config.side_space_mobile : config.side_space
    const side_bottom = isMobile ? config.side_bottom_mobile : config.side_bottom
    let newLeft = 0
    let newTop = 0

    switch (config.position) {
      case 'top_left':
        newLeft = side_space
        newTop = side_bottom
        break
      case 'top_right':
        newLeft = containerRect.width - config.size_widget - side_space
        newTop = side_bottom
        break
      case 'bottom_left':
        newLeft = side_space
        newTop = containerRect.height - config.size_widget - side_bottom
        break
      case 'bottom_right':
        newLeft = containerRect.width - config.size_widget - side_space
        newTop = containerRect.height - config.size_widget - side_bottom
        break
      default:
        break
    }

    if (containerPosition) {
      const containerRect = containerPosition.getBoundingClientRect()
      newLeft += containerRect.left
      newTop += containerRect.top
      draggableRef.current.style.position = 'absolute'
    } else {
      draggableRef.current.style.position = config.type || 'fixed'
    }

    draggableRef.current.classList.add(`videoshop-position-${config.position}`)
    draggableRef.current.style.left = `${newLeft}px`
    draggableRef.current.style.top = `${newTop}px`
  }

  // Add effect for handling position updates and resize
  useEffect(() => {
    if (!reelsData?.config) return

    const containerIframe = getIframeContainer()

    const handleResize = () => {
      changePosition(containerIframe || null)
    }

    if (containerIframe) {
      const resizeObserver = new ResizeObserver(handleResize)
      resizeObserver.observe(containerIframe)

      return () => {
        resizeObserver.disconnect()
      }
    } else {
      const mediaWatcher = window.matchMedia('screen and (max-width: 600px)')

      const updateMediaSize = (e) => {
        if (e.matches) {
          changePosition(null)
        }
      }

      if (mediaWatcher.addEventListener) {
        mediaWatcher.addEventListener('change', updateMediaSize)
      } else {
        mediaWatcher.addListener(updateMediaSize)
      }

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', handleResize)
      } else {
        window.addEventListener('resize', handleResize)
      }

      handleResize()

      return () => {
        if (mediaWatcher.removeEventListener) {
          mediaWatcher.removeEventListener('change', updateMediaSize)
        } else {
          mediaWatcher.removeListener(updateMediaSize)
        }
        window.removeEventListener('resize', handleResize)
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', handleResize)
        } else {
          window.removeEventListener('resize', handleResize)
        }
      }
    }
  }, [reelsData?.config, hasBeenManuallyPositioned])

  // Function to update close button position
  const updateCloseButtonPosition = () => {
    const closeButton = closeButtonRef.current
    const borderThumb = borderThumbRef.current

    if (borderThumb && closeButton) {
      const thumbWidth = borderThumb.offsetWidth
      const thumbHeight = borderThumb.offsetHeight
      const closeButtonWidth = closeButton.offsetWidth
      const closeButtonHeight = closeButton.offsetHeight

      // Separate radii for x and y
      const radiusX = thumbWidth / 2
      const radiusY = thumbHeight / 2

      // Use 135 degrees for top-left
      const angle = 135 * (Math.PI / 180)

      const centerX = radiusX
      const centerY = radiusY

      const offset = closeButtonWidth * 0.35

      const posX = centerX + (radiusX - offset) * Math.cos(angle) - closeButtonWidth / 2
      const posY = centerY + radiusY * Math.sin(angle) - closeButtonHeight / 2

      closeButton.style.left = `${posX}px`
      closeButton.style.top = `${posY + 8}px`
    }
  }

  // Effect for handling resize observer
  useEffect(() => {
    if (!borderThumbRef.current) return

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(updateCloseButtonPosition)
    })

    resizeObserver.observe(borderThumbRef.current)
    updateCloseButtonPosition() // Initial position update

    return () => {
      resizeObserver.disconnect()
    }
  }, [reelsData]) // Re-run when reelsData changes as it might affect sizes

  // Remove the video content useEffect and render the content directly
  const renderVideoContent = () => {
    if (!reelsData) return null
    const { config, collection } = reelsData

    if (collection.type === 'live') {
      if (!collection.thumb) return null

      return (
        <img
          src={collection.thumb}
          alt="Live"
          style={{
            objectFit: 'cover',
            objectPosition: 'center',
            userSelect: 'none',
            width: config.size_widget ? `${config.size_widget}px` : '100%',
            height: config.size_widget ? `${config.size_widget}px` : '100%',
            maxWidth: '100%',
            maxHeight: '100%',
          }}
        />
      )
    }

    if (collection.medias[0]?.mime_type === 'video/youtube') {
      return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
          <iframe
            loading="eager"
            src={`https://www.youtube.com/embed/${collection.medias[0].name}?autoplay=1&mute=1&controls=0&showinfo=0&rel=0&modestbranding=1`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              width: '100%',
              height: '100%',
              maxWidth: config.size_widget ? `${config.size_widget}px` : '100%',
              maxHeight: config.size_widget ? `${config.size_widget}px` : '100%',
              objectFit: 'cover',
              userSelect: 'none',
              pointerEvents: 'none',
              willChange: 'transform',
              transform: 'translateZ(0)',
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 1,
              cursor: 'pointer',
            }}
          />
        </div>
      )
    }

    if (collection.medias[0]?.url) {
      const preloadLink = document.createElement('link')
      preloadLink.rel = 'preload'
      preloadLink.as = 'video'
      preloadLink.href = collection.medias[0].url
      document.head.appendChild(preloadLink)

      return (
        <video
          muted
          loop
          autoPlay
          playsInline
          disablePictureInPicture
          preload="auto"
          fetchPriority="high"
          {...{ 'webkit-playsinline': 'true' }}
          style={{
            transition: 'transform 0.1s ease',
            willChange: 'transform',
            width: '100%',
            height: '100%',
            maxWidth: config.size_widget ? `${config.size_widget}px` : '100%',
            maxHeight: config.size_widget ? `${config.size_widget}px` : '100%',
            objectFit: 'cover',
            userSelect: 'none',
            transform: 'translateZ(0)',
          }}
        >
          <source src={collection.medias[0]?.url} type={collection.medias[0]?.mime_type} />
        </video>
      )
    }

    return null
  }

  const handleTouchStart = (e: React.TouchEvent) => {
    e.preventDefault()
    const touch = e.touches[0]
    startPos.current = { x: touch.clientX, y: touch.clientY }
    dragDistance.current = { x: 0, y: 0 }
    setIsDragging(false)
    isMouseUp.current = false

    const rect = draggableRef.current.getBoundingClientRect()
    dragOffset.current = {
      x: touch.clientX - rect.left,
      y: touch.clientY - rect.top,
    }
    lastPos.current = { x: touch.clientX, y: touch.clientY }

    if (draggableRef.current) {
      draggableRef.current.style.cursor = 'grabbing'
      draggableRef.current.classList.remove('bounce')
    }
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current)
    }
  }

  const handleTouchMove = (e: React.TouchEvent) => {
    const touch = e.touches[0]
    const moveX = Math.abs(touch.clientX - startPos.current.x)
    const moveY = Math.abs(touch.clientY - startPos.current.y)
    const threshold = getDragThreshold()

    if (moveX > threshold || moveY > threshold) {
      setIsDragging(true)
      dragDistance.current = {
        x: touch.clientX - lastPos.current.x,
        y: touch.clientY - lastPos.current.y,
      }
      setHasBeenManuallyPositioned(true)
      moveElement(touch.clientX, touch.clientY)
      velocityRef.current = {
        x: capVelocity(touch.clientX - lastPos.current.x, MAX_VELOCITY),
        y: capVelocity(touch.clientY - lastPos.current.y, MAX_VELOCITY),
      }
      lastPos.current = { x: touch.clientX, y: touch.clientY }
    }
  }

  const handleTouchEnd = (e: React.TouchEvent) => {
    const touch = e.changedTouches[0]
    const moveX = Math.abs(touch.clientX - startPos.current.x)
    const moveY = Math.abs(touch.clientY - startPos.current.y)
    const threshold = getTapThreshold()
    const isMisdrag = moveX < threshold && moveY < threshold

    if ((isOldAndroid() ? true : !isDragging) && isMisdrag) {
      if (iframeRef.current) {
        iframeRef.current.style.display = 'block'
        iframeRef.current.contentWindow?.postMessage({ type: 'OPEN_REELS' }, '*')
      }
    }

    setIsDragging(false)
    dragDistance.current = { x: 0, y: 0 }
    if (draggableRef.current) {
      draggableRef.current.style.cursor = 'grab'
    }
    hitCount.current = 0
    animateBounce()
  }

  const handleTouchCancel = (e: React.TouchEvent) => {
    e.preventDefault()
    setIsDragging(false)
    dragDistance.current = { x: 0, y: 0 }
    if (draggableRef.current) {
      draggableRef.current.style.cursor = 'grab'
    }
    hitCount.current = 0
  }

  if (!showWidget || !reelsData) return null
  const { config, collection } = reelsData

  // Calculate text display conditions
  const showReplayText = collection.highlight && collection.highlight !== '' && collection.type !== 'live'
  const showLiveHighlight = collection.type === 'live' && collection.highlight && collection.highlight !== ''

  // Calculate text block classes
  const textBlockClasses = ['replay-texto']
  if (config.highlight_orientation) {
    textBlockClasses.push(`replay-position-textblock_${config.highlight_orientation}`)
  }

  return (
    <div
      ref={draggableRef}
      className={`drag-replay-empreender videoshop-position-${config.position}`}
      style={{
        display: 'block',
        width: `${config.size_widget}px`,
        height: `${config.size_widget}px`,
        cursor: isDragging ? 'grabbing' : 'pointer',
        zIndex: 9999,
      }}
      onClick={(e) => {
        const isMisdrag = Math.abs(dragDistance.current.x) < DRAG_THRESHOLD && Math.abs(dragDistance.current.y) < DRAG_THRESHOLD
        if (!isDragging && isMisdrag && !isMouseUp.current) {
          if (iframeRef.current) {
            iframeRef.current.style.display = 'block'
            if (isPreview) {
              iframeRef.current.contentWindow?.postMessage(
                { type: 'OPEN_REELS', preview: true, data: { config: { data: config }, collection: collection } },
                '*'
              )
            } else {
              iframeRef.current.contentWindow?.postMessage({ type: 'OPEN_REELS' }, '*')
            }
          }
        } else {
          e.stopPropagation()
          e.preventDefault()
        }
      }}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onTouchCancel={handleTouchCancel}
    >
      <div style={{ position: 'relative' }}>
        <button
          ref={closeButtonRef}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setShowWidget(false)
          }}
          onTouchStart={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setShowWidget(false)
          }}
          style={{
            position: 'absolute',
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            backgroundColor: config.border_color,
            border: 'none',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1,
            padding: '7px',
          }}
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1L11 11M1 11L11 1" stroke={config.color_high} strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
        <div
          ref={replayTextRef}
          className={`${textBlockClasses.join(' ')}`}
          style={
            {
              display: showReplayText ? 'flex' : 'none',
              backgroundColor: config.background_high,
              color: config.color_high,
              '--content-width-replay-texto': `${collection.highlight?.length}ch`,
            } as React.CSSProperties
          }
        >
          {collection.highlight}
        </div>
        <div
          className="replay-live highlight-badge"
          style={{
            display: showLiveHighlight ? 'flex' : 'none',
          }}
        >
          {showLiveHighlight && (
            <>
              <span className="highlight-dot" />
              <span className="highlight-text">{collection.highlight}</span>
            </>
          )}
        </div>
        <div
          ref={borderThumbRef}
          className="replay-border-thumb"
          style={{
            width: `${config.size_widget}px`,
            height: `${config.size_widget}px`,
            backgroundColor: config.border_color,
            borderColor: config.border_color,
            borderWidth: `${config.size_border}px`,
            borderStyle: 'solid',
            borderRadius: '50%',
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          {urlReels && (
            <iframe
              ref={iframeRef}
              loading="eager"
              allow="autoplay; encrypted-media"
              src={urlReels}
              style={{
                display: 'none',
                position: 'fixed',
                top: 0,
                left: 0,
                border: 'none',
                width: '100%',
                height: '100%',
                zIndex: 99999,
                outline: 'none',
                paddingBottom: 'env(safe-area-inset-bottom)',
              }}
            />
          )}
          <div ref={videoContainerRef}>{renderVideoContent()}</div>
        </div>
      </div>
    </div>
  )
}
